/**
 * Logo file → company name mapping (matches actual artwork in public/img/*).
 * Do not use index-based name lists; filenames are not in vendor-list order.
 */
export const partnerLogoByFolder = {
  cybersecurity: [
    { file: "1.png", name: "Fortinet" },
    { file: "2.png", name: "Palo Alto Networks" },
    { file: "3.png", name: "Check Point" },
    { file: "4.png", name: "Juniper Networks" },
    { file: "5.png", name: "Netskope" },
    { file: "6.png", name: "Sophos" },
    { file: "7.svg", name: "Zscaler" },
    { file: "8.png", name: "Forcepoint" },
    { file: "9.png", name: "Trend Micro" },
    { file: "10.png", name: "SonicWall" },
    { file: "11.png", name: "Barracuda" },
    { file: "12.png", name: "Cisco" },
    { file: "13.png", name: "F5" },
    { file: "14.png", name: "ManageEngine" },
    { file: "16.png", name: "Radware" },
    { file: "17.png", name: "WatchGuard" },
    { file: "18.svg", name: "Cloudflare" },
  ],
  "enterprise-networking": [
    { file: "1.png", name: "Cisco" },
    { file: "2.png", name: "Aruba" },
    { file: "3.png", name: "Ruckus Networks" },
    { file: "4.png", name: "Fortinet" },
    { file: "5.png", name: "D-Link" },
    { file: "6.png", name: "TP-Link" },
    { file: "7.png", name: "CommScope" },
    { file: "8.png", name: "HPE" },
    { file: "9.png", name: "A10 Networks" },
    { file: "10.png", name: "Alcatel-Lucent Enterprise" },
    { file: "11.png", name: "Arista Networks" },
    { file: "12.png", name: "Extreme Networks" },
  ],
  "infrastructure-solutions": [
    { file: "1.png", name: "NetApp" },
    { file: "2.png", name: "HPE" },
    { file: "3.png", name: "Dell Technologies" },
    { file: "4.png", name: "Lenovo" },
    { file: "5.png", name: "Acer" },
    { file: "6.png", name: "Nutanix" },
    { file: "7.png", name: "IBM" },
    { file: "8.png", name: "Quantum" },
    { file: "9.png", name: "Apple" },
    { file: "10.png", name: "Hitachi Vantara" },
    { file: "11.png", name: "DDN" },
    { file: "12.png", name: "Pure Storage" },
  ],
  "data-security": [
    { file: "1.png", name: "CrowdStrike" },
    { file: "2.png", name: "SentinelOne" },
    { file: "3.svg", name: "Microsoft" },
    { file: "4.png", name: "Proofpoint" },
    { file: "5.svg", name: "Broadcom (Symantec)" },
    { file: "6.png", name: "Sophos" },
  ],
  antivirus: [
    { file: "1.png", name: "Trellix" },
    { file: "2.png", name: "Bitdefender" },
    { file: "3.png", name: "Quick Heal" },
    { file: "4.png", name: "ESCAN" },
    { file: "5.png", name: "Kaspersky" },
    { file: "6.svg", name: "Microsoft Defender" },
    { file: "7.png", name: "Commvault" },
    { file: "8.svg", name: "Trend Micro" },
    { file: "9.svg", name: "Bitdefender" },
    { file: "10.png", name: "ESET" },
  ],
  "software-solutions": [
    { file: "1.png", name: "Adobe" },
    { file: "2.png", name: "Microsoft" },
    { file: "3.png", name: "Oracle" },
    { file: "4.svg", name: "Adobe" },
    { file: "5.svg", name: "Oracle" },
  ],
  "cloud-service": [
    { file: "1.png", name: "AWS" },
    { file: "2.png", name: "Google Cloud Platform (GCP)" },
    { file: "3.png", name: "Microsoft Azure" },
    { file: "4.svg", name: "Microsoft Azure" },
    { file: "5.svg", name: "Oracle Cloud Infrastructure (OCI)" },
    { file: "6.svg", name: "IBM Cloud" },
    { file: "7.png", name: "Neon Cloud by Progression" },
    { file: "8.svg", name: "Yotta Cloud" },
  ],
  backup: [
    { file: "1.png", name: "Veeam" },
    { file: "2.png", name: "Commvault" },
    { file: "3.png", name: "Veritas" },
    { file: "4.png", name: "Druva" },
    { file: "5.png", name: "Acronis" },
    { file: "6.svg", name: "Cohesity" },
    { file: "7.svg", name: "Dell Technologies" },
    { file: "8.svg", name: "Veritas" },
  ],
  computing: [
    { file: "1.png", name: "HP" },
    { file: "2.png", name: "Samsung" },
    { file: "3.png", name: "Dell" },
    { file: "4.png", name: "LG" },
    { file: "5.png", name: "Epson" },
    { file: "6.png", name: "ViewSonic" },
    { file: "7.png", name: "Zebra" },
    { file: "8.png", name: "Canon" },
    { file: "9.png", name: "Pantum" },
    { file: "10.svg", name: "MSI" },
  ],
  virtualization: [
    { file: "1.svg", name: "VMware" },
    { file: "2.svg", name: "Microsoft Hyper-V" },
    { file: "3.svg", name: "Red Hat" },
    { file: "4.svg", name: "Nutanix" },
    { file: "5.svg", name: "Proxmox" },
    { file: "6.svg", name: "Citrix" },
    { file: "7.svg", name: "Oracle VM" },
  ],
  cctv: [
    { file: "1.png", name: "CP Plus" },
    { file: "2.png", name: "Hikvision" },
    { file: "3.png", name: "Honeywell" },
    { file: "5.png", name: "Axis Communications" },
    { file: "6.png", name: "Ajuha" },
    { file: "7.png", name: "Commvault" },
  ],
  "audio-video-conferencing-solutions": [
    { file: "1.png", name: "Cisco" },
    { file: "2.png", name: "Poly" },
    { file: "3.png", name: "Logitech" },
    { file: "4.png", name: "Harman" },
    { file: "5.png", name: "Avaya" },
    { file: "6.png", name: "Telesoft" },
    { file: "7.svg", name: "Microsoft Teams" },
    { file: "8.svg", name: "Zoom" },
    { file: "9.png", name: "Google Workspace" },
    { file: "10.png", name: "Yealink" },
    { file: "11.png", name: "Barco" },
  ],
  "online-UPS": [
    { file: "1.png", name: "Microtek" },
    { file: "2.png", name: "APC by Schneider Electric" },
    { file: "3.png", name: "Luminous" },
    { file: "4.png", name: "Emerson (Vertiv)" },
    { file: "5.png", name: "Delta" },
    { file: "6.png", name: "Eaton" },
  ],
  "business-analytics": [
    { file: "1.jpg", name: "Alteryx" },
    { file: "2.jpeg", name: "Elastic" },
    { file: "3.png", name: "Cloudera" },
    { file: "4.jpeg", name: "KNIME" },
    { file: "5.png", name: "Liferay" },
    { file: "6.png", name: "Jedox" },
    { file: "7.png", name: "Microsoft Power BI" },
    { file: "8.png", name: "Qlik" },
    { file: "9.png", name: "SAS" },
    { file: "10.jpg", name: "Tableau" },
    { file: "11.png", name: "Teradata" },
    { file: "12.jpeg", name: "TIBCO" },
    { file: "13.svg", name: "Google Looker" },
    { file: "14.png", name: "Domo" },
  ],
  database: [
    { file: "1.svg", name: "Oracle Database" },
    { file: "2.svg", name: "Microsoft SQL Server" },
    { file: "3.svg", name: "PostgreSQL" },
    { file: "4.svg", name: "MySQL" },
    { file: "5.svg", name: "MongoDB" },
    { file: "6.svg", name: "Cloudera" },
  ],
};
